import { ApiRoutes } from "consts/enpoints/api";
import { HttpVerb } from "consts/api";
import { fetchApi } from "infrastructure/api";
import type {
    BankingSdkConnector,
    BankingSdkConnectorsRecipientsPivot,
    BankingSdkRecipient,
    IbanXsBank,
    IbanXsBanksCountriesPivot,
    IbanXsBanksRecipientsPivot,
    WithConnectors
} from "./types";

export const getBankingSdkConnectors = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetBankingSdkConnectors}${queryString}`);

export const updateBankingSdkConnector = ({ pki, ...body }: Partial<BankingSdkConnector>) =>
    fetchApi(ApiRoutes.PutBankingSdkConnectors(pki), {
        method: HttpVerb.Put,
        body
    });

export const massUpdateBankingSdkConnectors = (body: WithConnectors<
    Pick<BankingSdkConnector, 'countryISO'>
>) =>
    fetchApi(ApiRoutes.PutBankingSdkConnectors(), {
        method: HttpVerb.Put,
        body
    });

export const getIbanXsBanks = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetIbanXsBanks}${queryString}`);

export const updateIbanXsBanks = ({ pki, ...body }: Partial<IbanXsBank>) =>
    fetchApi(ApiRoutes.PutIbanXsBanks(pki), {
        method: HttpVerb.Put,
        body
    });

export const getBankingSdkRecipients = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetBankingSdkRecipients}${queryString}`);

export const createBankingSdkRecipient = (body: Partial<BankingSdkRecipient>) =>
    fetchApi(ApiRoutes.PostBankingSdkRecipients, {
        method: HttpVerb.Post,
        body
    });

export const updateBankingSdkRecipient = ({ coreId, ...body }: Partial<BankingSdkRecipient>) =>
    fetchApi(ApiRoutes.PutBankingSdkRecipients(coreId), {
        method: HttpVerb.Put,
        body
    });

export const deleteBankingSdkRecipient = ({ coreId }: Pick<BankingSdkRecipient, 'coreId'>) =>
    fetchApi(ApiRoutes.DeleteBankingSdkRecipients(coreId), {
        method: HttpVerb.Delete
    });

export const getBankingSdkConnectorsRecipientsPivot = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetBankingSdkConnectorsRecipientsPivot}${queryString}`);

export const createBankingSdkConnectorsRecipientsPivot = (body: Partial<BankingSdkConnectorsRecipientsPivot>) =>
    fetchApi(ApiRoutes.PostBankingSdkConnectorsRecipientsPivot, {
        method: HttpVerb.Post,
        body
    });

export const updateBankingSdkConnectorsRecipientsPivot = ({ pki, ...body }: Partial<BankingSdkConnectorsRecipientsPivot>) =>
    fetchApi(ApiRoutes.PutBankingSdkConnectorsRecipientsPivot(pki), {
        method: HttpVerb.Put,
        body
    });

export const deleteBankingSdkConnectorsRecipientsPivot = ({ coreId }: Pick<BankingSdkConnectorsRecipientsPivot, 'coreId'>) =>
    fetchApi(ApiRoutes.DeleteBankingSdkConnectorsRecipientsPivot(coreId), {
        method: HttpVerb.Delete
    });

export const getIbanXsBanksRecipientsPivot = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetIbanXsBanksRecipientsPivot}${queryString}`);

export const createIbanXsBanksRecipientsPivot = (body: Partial<IbanXsBanksRecipientsPivot>) =>
    fetchApi(ApiRoutes.PostIbanXsBanksRecipientsPivot, {
        method: HttpVerb.Post,
        body
    });

export const updateIbanXsBanksRecipientsPivot = ({ pki, ...body }: Partial<IbanXsBanksRecipientsPivot>) =>
    fetchApi(ApiRoutes.PutIbanXsBanksRecipientsPivot(pki), {
        method: HttpVerb.Put,
        body
    });

export const deleteIbanXsBanksRecipientsPivot = ({ coreId }: Pick<IbanXsBanksRecipientsPivot, 'coreId'>) =>
    fetchApi(ApiRoutes.DeleteIbanXsBanksRecipientsPivot(coreId), {
        method: HttpVerb.Delete
    });

export const getIbanXsBanksCountriesPivot = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetIbanXsBanksCountriesPivot}${queryString}`);

export const createIbanXsBanksCountriesPivot = (body: Partial<IbanXsBanksCountriesPivot>) =>
    fetchApi(ApiRoutes.PostIbanXsBanksCountriesPivot, {
        method: HttpVerb.Post,
        body
    });

export const updateIbanXsBanksCountriesPivot = ({ pki, ...body }: Partial<IbanXsBanksCountriesPivot>) =>
    fetchApi(ApiRoutes.PutIbanXsBanksCountriesPivot(pki), {
        method: HttpVerb.Put,
        body
    });

export const massUpdateIbanXsBanksCountriesPivot = (body: WithConnectors<
    Pick<IbanXsBanksCountriesPivot, 'iso2'>
>) =>
    fetchApi(ApiRoutes.PutIbanXsBanksCountriesPivot(), {
        method: HttpVerb.Put,
        body
    });

export const deleteIbanXsBanksCountriesPivot = ({ coreId }: Pick<IbanXsBanksCountriesPivot, 'coreId'>) =>
    fetchApi(ApiRoutes.DeleteIbanXsBanksCountriesPivot(coreId), {
        method: HttpVerb.Delete
    });
